<template>
  <v-container fluid class="help">
    
    <v-row>
      <v-col class="text-center">
        <h1> TERAS iDEAS CONVENTION 2023 </h1>
        <h3> Agency Strategy</h3>
        <h5> by En Fahmi Hatta</h5>
        <br><br>
        
        <v-btn
          color="orange"
          text
          outlined
          :href="prodSrc"
          target="_blank"
        >
          Download PDF
        </v-btn>
        <br><br>
        <p class="sub-title" v-if="isLoading">Loading...</p>
        <p class="sub-title" v-if="isErrorLoading">Error... Cannot render...</p>  
        
      </v-col>
    </v-row>
    <br><br>
    <vue-pdf-embed 
      :source="prodSrc"
      @rendered="handleDocRender"
      @progress="hanldeDocProgress"
      @loading-failed="handleLoadingFailed"/>
      
    
    <br>
    
  
  </v-container>
</template>

<script>

import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  components: {
    VuePdfEmbed,
  },

  data: () => ({
    isLoading: true,
    isErrorLoading: false,
    prodSrc: 'https://teraslegacy.com/wp-content/uploads/2023/01/Agency-Strategy-by-En-Fahmi-Hatta.pdf',
    
  }),

  methods: {
    handleDocRender (args) {
      console.log('handleDocRender : ' + args)
      this.isLoading = false
      this.isErrorLoading = false
    },
    handleDocProgress(args) {
      console.log('handleDocProgress : ' + args);
      this.isLoading = true
      this.isErrorLoading = false
    },
    handleLoadingFailed(args) {
      console.log('handleLoadingFailed : ' + args);
      this.isLoading = false
      this.isErrorLoading = true
    }
  },

  mounted() {

  }
}
</script>
